import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/religion';
const backUrl='/setting'+Url;
 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            religion_name:'', 
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;
                    this.setState({
                        religion_name:data.religion_name?data.religion_name:'', 
                        preloader:false, 
                    });
                }
            });
        }
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let params={
                religion_name:this.state.religion_name,
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader,religion_name} = this.state;
        let role=permissionCheck('religion',title);
        if(!role)
            return <Nopermission/>;
        const religion_nameValid= this.validator.message('Religion',religion_name, 'required');
        return (
            <div id="page_content_inner" className="uk-width-medium-4-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{title} Religion</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${religion_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Religion<span className="req">*</span></label>
                                    <input type="text" name="religion_name" value={religion_name} onChange={this.setStateFromInput} className={ `md-input ${religion_nameValid ?'md-input-danger':''}`} /> 
                                    {religion_nameValid} 
                                </div>
                            </div>
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1">
                                <Link to={backUrl} className="md-btn md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Setting/Religion/addEdit.js